<template>
  <div class="comp-full-calendar">
    <fc-header
      :current-month="currentMonth"
      :first-day="firstDay"
      :btnShow="btnStyle"
      :locale="locale"
      @change="emitChangeMonth"
      class="flight-head"
    ></fc-header>
    <div class="full-calendar-body">
      <div class="weeks">
        <strong class="week weekend">周日</strong>
        <strong class="week">周一</strong>
        <strong class="week">周二</strong>
        <strong class="week">周三</strong>
        <strong class="week">周四</strong>
        <strong class="week">周五</strong>
        <strong class="week weekend">周六</strong>
      </div>
      <div class="dates" ref="dates">
        <div class="dates-bg">
          <div class="week-row" v-for="(week,index) in currentDates" :key="Math.random()+index">
            <div
              class="day-cell"
              v-for="(day,sindex) in week"
              :class="{
              'not-cur-month' : !day.isCurMonth,'isToday':day.isToday}"
              :data-istoday="day.isToday?'today':''"
              @click.stop="dayClick(day.date, $event,day,index,sindex,day.isCurMonth)"
              :key="Math.random()-sindex"
            >
              <p class="day-number">{{ day.isToday?'今天':day.monthDay}}</p>
              <div class="fligth-price" v-if="day.events.price">
                <span class="low-price" :data-istoday="day.isToday?'today':''">
                  ￥{{day.events.price}}
                  <i>低</i>
                </span>
                <!-- <span v-if="day.events.productType==1">￥{{day.events.price}}</span> -->
              </div>
            </div>
          </div>
        </div>
        <p style="font-size: 12px;color: #666666;padding:10px 0 ">机票价格变动频繁，以实际成交价为准。</p>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import dateFunc from "./components/dateFunc";
import moment from "moment";
import EventCard from "./components/eventCard.vue";
import vHeader from "./components/header.vue";

export default {
  props: {
    events: {
      type: Array,
      default: () => []
    },
    locale: {
      type: String,
      default: "en"
    },
    selectStatus: {
      type: Number,
      default: 2
    },
    firstDay: {
      type: Number | String,
      validator(val) {
        let res = parseInt(val);
        return res >= 0 && res <= 7;
      },
      default: 0
    },
    initialDayTime: {
      type: Number,
      default: 0
    },
    deleteGroupDate: {
      type: Array,
      default: () => []
    },
    clickType: {
      type: String,
      default: "checkbox" // 'checkbox': 多选显示勾勾，原本的逻辑; 'radio': 新增的，单选，不显示勾勾，不执行多选逻辑
    }
  },
  components: {
    "event-card": EventCard,
    "fc-header": vHeader
  },
  watch: {
    deleteGroupDate(val) {
      this.saveDateList = val;
      this.getCalendar();
    },
    initialDayTime(val) {
      for (let time in this.formTime) {
        this.formTime[time] = this.eventBox;
      }
    }
  },

  data() {
    return {
      currentMonth: moment().startOf("month"),
      isLismit: true,
      eventLimit: 3,
      eventBox: [],
      formTime: {},
      timeKey: "",
      showMore: false,
      showList: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {},
      saveDateList: [],
      btnStyle: true
    };
  },
  computed: {
    currentDates() {
      return this.getCalendar();
    }
  },

  methods: {
    setEventBox(index, zindex) {
      // console.log(index,zindex)
    },
    emitChangeMonth(firstDayOfMonth) {
      let nowDate = new Date(moment().format("YYYY-MM-01 00:00:00")).valueOf();
      let clickMonth = new Date(firstDayOfMonth).valueOf();
      if (clickMonth >= nowDate) {
        this.btnStyle = false;
        this.currentMonth = firstDayOfMonth;
        let start = dateFunc.getMonthViewStartDate(
          firstDayOfMonth,
          this.firstDay
        );
        let end = dateFunc.getMonthViewEndDate(firstDayOfMonth, this.firstDay);
        this.$emit("changeMonth", start, end, firstDayOfMonth);
        clickMonth === nowDate ? (this.btnStyle = true) : "";
      }
      // this.saveTime(firstDayOfMonth._d)
    },
    saveTime(time) {
      let date = time;
      let key = (this.timeKey =
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getDate());
      let formTime = {};
      formTime = this.formTime;
      let arr = Object.keys(formTime);
      if (arr.length > 0) {
        if (arr.indexOf(key) > -1) {
          return true;
        } else {
          formTime[key] = JSON.parse(JSON.stringify(this.eventBox));
        }
      } else {
        formTime[key] = JSON.parse(JSON.stringify(this.eventBox));
      }
    },
    moreTitle(date) {
      if (!date) return "";
      return moment(date).format("ll");
    },
    getCalendar() {
      // calculate 2d-array of each month
      let monthViewStartDate = dateFunc.getMonthViewStartDate(
        this.currentMonth,
        this.firstDay
      );
      let calendar = [];
      for (let perWeek = 0; perWeek < 6; perWeek++) {
        let week = [];

        for (let perDay = 0; perDay < 7; perDay++) {
          let isShow = false;
          this.saveDateList.map(saveDate => {
            if (saveDate === moment(monthViewStartDate).format("YYYY-MM-DD")) {
              isShow = true;
            }
          });

          week.push({
            monthDay: monthViewStartDate.date(),
            isToday: monthViewStartDate.isSame(moment(), "day"),
            isCurMonth: monthViewStartDate.isSame(this.currentMonth, "month"),
            weekDay: perDay,
            date: moment(monthViewStartDate),
            events: this.filterGroup(this.events, monthViewStartDate),
            isShow: isShow
          });
          monthViewStartDate.add(1, "day");
        }
        calendar.push(week);
      }
      return calendar;
    },
    filterGroup(list, date) {
      let events = {};
      list.map(item => {
        if (
          moment(item.depDate).format("YYYY-MM-DD") ===
          date.format("YYYY-MM-DD")
        ) {
          events = {
            price: item.ticketPrice,
            date: moment(item.depDate).format("YYYY-MM-DD"),
            productType: item.productType
          };
        }
      });
      return events;
    },
    slotEvents(date) {
      // find all events start from this date
      // let cellIndexArr = [];
      let thisDayEvents = this.events.filter(day => {
        let st = moment(day.start);
        let ed = moment(day.end ? day.end : st);

        return date.isBetween(st, ed, null, "[]");
      });

      // sort by duration
      thisDayEvents.sort((a, b) => {
        if (!a.cellIndex) return 1;
        if (!b.cellIndex) return -1;
        return a.cellIndex - b.cellIndex;
      });

      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || i + 1;
        thisDayEvents[i].isShow = true;
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue;
        thisDayEvents.splice(i, 0, {
          title: "holder",
          cellIndex: i + 1,
          start: date.format(),
          end: date.format(),
          isShow: false
        });
      }

      return thisDayEvents;
    },
    selectThisDay(day, jsEvent) {
      this.selectDay = day;
      this.showMore = true;
      this.morePos = this.computePos(event.target);
      this.morePos.top -= 100;
      let events = day.events.filter(item => {
        return item.isShow === true;
      });
      this.$emit("moreClick", day.date, events, jsEvent);
    },
    computePos(target) {
      let eventRect = target.getBoundingClientRect();
      let pageRect = this.$refs.dates.getBoundingClientRect();
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      };
    },
    dayClick(day, jsEvent, data, index, zindex, monthShow) {
      // console.log(day)
      // if (Object.keys(data.events).length === 0) return;
      // if (this.clickType === "checkbox") {
      //   // 多选清空才改变
      //   data.isShow = !data.isShow;
      //   this.$forceUpdate();
      //   if (data.isShow) {
      //     this.saveDateList.push(day.format("YYYY-MM-DD"));
      //   } else {
      //     let saveArr = [];
      //     saveArr = this.saveDateList.filter(item => {
      //       return item !== day.format("YYYY-MM-DD");
      //     });
      //     this.saveDateList = saveArr;
      //   }
      // }
      this.$emit("dayClick", data, jsEvent);
    },
    eventClick(event, jsEvent) {
      if (!event.isShow) return;
      jsEvent.stopPropagation();
      let pos = this.computePos(jsEvent.target);
      this.$emit("eventClick", event, jsEvent, pos);
    }
  },
  filters: {
    localeWeekDay(weekday, firstDay, locale) {
      firstDay = parseInt(firstDay);
      const localMoment = moment().locale(locale);
      let week = localMoment
        .localeData()
        .weekdaysShort()
        [(weekday + firstDay) % 7].substring(1);
      return week;
    }
  }
};
</script>
<style lang="less" scoped>
.comp-full-calendar {
  padding: 10px;
  background: #fff;
  margin: 0 auto;
  border: 0.5px solid #dfdfdf;
  ul,
  p {
    margin: 0;
    padding: 0;
  }
}

.full-calendar-body {
  margin-top: 5px;
  .weeks {
    display: flex;
    border: 1px solid #e0e0e0;
    border-right: 0;
    // background: #68798b;
    color: #333;
    font-weight: bold;
    // height: 46px;
    font-size: 14px;
    line-height: 30px;
    strong {
      border-right: 1px solid #dfdfdf;
    }
    .week {
      flex: 1;
      text-align: center;
      // border-right:1px solid #e0e0e0;
    }
    .weekend {
      // background-color: #237dc8;
    }
  }
  .dates {
    position: relative;
    .week-row {
      // width: 100%;
      // position:absolute;
      border-left: 1px solid #e0e0e0;
      display: flex;
      .day-cell {
        cursor: pointer;
        flex: 1;
        font-size: 13px;
        height: 50px;
        padding: 4px;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
        position: relative;
        .day-event {
          // cursor: default;
          cursor: pointer;
          &.day-top {
            padding-top: 16px;
          }
          p {
            text-align: center;
            font-size: 12px;
          }
        }
        .day-number {
          text-align: left;
          position: relative;
          z-index: 9;
        }
        &.today {
          //  background-color:#fcf8e3;
          background-color: #f2f2f2;
        }
        &.not-cur-month {
          color: #999;
          background: #f8f8f8;
          .fligth-price {
            color: #999 !important;
          }
        }
        &:hover:not([data-istoday="today"]) {
          .fligth-price {
            color: #0086f6;
          }
        }

        .price-label {
          position: absolute;
          width: 31px;
          height: 32px;
          background: url("./images/price-label-bg.png") 0 0 no-repeat;
          top: 0;
          right: 10px;
        }
      }
    }
    .dates-events {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      .events-week {
        display: flex;
        // min-height: 122px;
        .events-day {
          cursor: pointer;
          flex: 1;
          // min-height: 122px;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;
          .day-number {
            text-align: left;
            // padding:4px 5px 4px 4px;
            opacity: 0;
          }

          &.not-cur-month {
            .day-number {
              color: rgba(0, 0, 0, 0.24);
              text-align: left;
            }
          }
          .event-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            .event-item {
              cursor: pointer;
              font-size: 12px;
              // margin-bottom:2px;
              color: rgba(0, 0, 0, 0.87);
              padding: 0 0 0 4px;
              line-height: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
              // min-height:122px;
              background: #f2f2f2;
              margin: 1px;
              &.is-start {
                //  margin-left: 4px;
                // border-top-left-radius:4px;
                // border-bottom-left-radius:4px;
              }
              &.is-end {
                //  margin-right: 4px;
                // border-top-right-radius:4px;
                // border-bottom-right-radius:4px;
              }
              &.is-opacity {
                opacity: 0;
              }
            }
            .more-link {
              cursor: pointer;
              // text-align: right;
              padding-left: 8px;
              padding-right: 2px;
              color: rgba(0, 0, 0, 0.38);
              font-size: 14px;
            }
          }
        }
      }
    }
    .more-events {
      position: absolute;
      width: 150px;
      z-index: 2;
      border: 1px solid #eee;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
      .more-header {
        background-color: #eee;
        padding: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .title {
          flex: 1;
        }
        .close {
          margin-right: 2px;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .more-body {
        height: 146px;
        overflow: hidden;
        .body-list {
          height: 144px;
          padding: 5px;
          overflow: auto;
          background-color: #fff;
          .body-item {
            cursor: pointer;
            font-size: 12px;
            background-color: #c7e6fd;
            margin-bottom: 2px;
            color: rgba(0, 0, 0, 0.87);
            padding: 0 0 0 4px;
            height: 18px;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.place {
  // margin-top: 8px;
  span {
    background: #999999;
    color: #ffffff;
    padding: 2px 4px;
  }
}
.team-info {
  padding-top: 2px;
  color: #8e8e8e;

  .stock_text {
    display: inline-block;
    background: #13ce66;
    color: #fff;
    width: 58px;
    height: 24px;
    line-height: 24px;
    border-radius: 6px;
    margin-top: 2px;
  }
  .stop_text {
    display: inline-block;
    background: #ff4949;
    color: #fff;
    width: 58px;
    height: 24px;
    line-height: 24px;
    border-radius: 6px;
    margin-top: 2px;
  }
  .stock_price {
    color: #ff6600;
  }
}
.event-box-ico {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: url("./images/gou.svg") center center;
  background-size: cover;
  display: block;
  position: absolute;
  bottom: 5px;
  right: 4px;
  z-index: 999;
}
.fligth-price {
  font-size: 12px;
  color: #333;
  font-weight: bold;
  i {
    font-style: normal;
  }
  .low-price:not([data-istoday="today"]) {
    color: #f60;
    font-size: 12px;
    i {
      color: white;
      background: #f60;
      padding: 1px 2px;
      border-radius: 4px;
    }
  }
}
/deep/.flight-head {
  .header-center {
    width: 200px;
    margin: auto;
  }
  .title {
    color: #333 !important;
    margin: 0 !important;
  }
  span {
    color: #227dc7 !important;
    background: white !important;
  }
  .noActive {
    color: #b2b2b2 !important;
  }
}
.isToday {
  background: #0086f6;
  color: white;
  .fligth-price {
    color: white;
  }
}
</style>
